/**
 * Contact API client — T0 Epic B.
 *
 * `POST /contacts` captures buyer→seller first contact and returns the
 * Click-to-WhatsApp deep link; `GET /contacts/mine` is the buyer's contact
 * list. Both are authenticated (HMAC + JWT) via the standard helpers.
 */
import { apiGet, apiPost } from '../../../adapters/api-client/api';

export type ContactChannel = 'WHATSAPP' | 'EMAIL' | 'PHONE' | 'PLATFORM';

export interface InitiateContactResponse {
  contact: { contactId: string; vehicleId: string; sellerId: string; channel: ContactChannel };
  whatsappUrl?: string;
  reused: boolean;
}

export interface MyContact {
  contact: {
    contactId: string;
    vehicleId: string;
    channel: ContactChannel;
    createdAt: string;
  };
  vehicle?: { id: string; title: string; listingPrice?: number };
}

export function initiateContact(
  vehicleId: string,
  channel: ContactChannel = 'WHATSAPP',
): Promise<InitiateContactResponse> {
  return apiPost<InitiateContactResponse>('/api/v1/contacts', { vehicleId, channel });
}

export async function fetchMyContacts(): Promise<MyContact[]> {
  const res = await apiGet<{ contacts: MyContact[] }>('/api/v1/contacts/mine');
  return res.contacts ?? [];
}
